import {
  MENU_THEME_STANDARD,
  getMenuTheme,
  getMenuBranding,
  getMenuAccentColor,
  isPremiumDarkMenu,
  isPremiumLightMenu,
  isPremiumMenu,
  getMenuPageStyle,
  STANDARD_CATALOG_LAYOUT,
} from '@/lib/menuTheme';

export function useCatalogTheme(business) {
  const theme = getMenuTheme(business);
  const standard = theme === MENU_THEME_STANDARD;
  const premium = isPremiumMenu(business);
  const pd = isPremiumDarkMenu(business);
  const pl = isPremiumLightMenu(business);
  const branding = premium ? getMenuBranding(business) : {};
  const accent = getMenuAccentColor(business);
  const tc = STANDARD_CATALOG_LAYOUT;
  const pageStyle = premium ? getMenuPageStyle(business) : undefined;

  return {
    theme,
    standard,
    premium,
    pd,
    pl,
    branding,
    accent,
    tc,
    pageStyle,
  };
}

export function useCatalogBootTheme(business) {
  const premium = isPremiumMenu(business);
  return {
    premium,
    pageStyle: premium ? getMenuPageStyle(business) : undefined,
    branding: premium ? getMenuBranding(business) : {},
    accent: getMenuAccentColor(business),
    standard: getMenuTheme(business) === MENU_THEME_STANDARD,
  };
}
